import { faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons';

export const FooterData = [
    {
        title: 'Documents',
        links: [
            { name: 'Overview', url: '#' },
            { name: 'How-to guides', url: '#' },
            { name: 'Community support', url: '#' }
        ]
    },
    {
        title: 'Senior Care',
        links: [
            { name: 'Products', url: '#' },
            { name: 'Software', url: '#' },
            { name: 'License', url: '#' },
            { name: 'Pricing', url: '#' },
            { name: 'Careers', url: '#' }
        ]
    },
    {
        title: 'Resources',
        links: [
            { name: 'Privacy Policy', url: '#' },
            { name: 'FAQ', url: '#' },
            { name: 'Forums', url: '#' },
            { name: 'News', url: '#' }
        ]
    },
    {
        title: 'Helps',
        links: [
            { name: 'Contact', url: '#' },
            { name: 'Support', url: '#' },
            { name: 'Feedback', url: '#' }
        ]
    },
    {
        socialMedia: [
            { name: faLinkedin, url: 'https://www.linkedin.com/company/senior-well' },
            { name: faGithub, url: 'https://github.com/Senior-well' }
        ]
    }
];